/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui-card-info{margin:0 0 10px;padding:16px;border-radius:4px;border-width:1px;border-style:solid;display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center}.ui-card-info .mat-icon{margin-right:10px}.ui-card-info-content{font-size:14px}"];
export { styles as styles };
